import { EChartsOption } from "echarts";
import React, { useEffect, useState } from "react";
import ChartBar from "../Bar";
import SideModal from "../../Layout/SideModal/SideModal";
import { MenuState } from "../../../store/reducers/menuReducer";
import { RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import LcIconLink from "../../Generic/LcIconLink";

interface Props {
  title: string;
  chartData?: any;
  detailed?: boolean;
  currentFilter: any
  onClickBar?: Function;
}

const BarDetailed: React.FC<Props> = (props) => {
  const menu = useSelector<RootState, MenuState>(state => state.menu);
  const [chartTitleSimple, setChartTitleSimple] = useState<any[]>([]);
  const [chartTitle, setChartTitle] = useState<string[]>([]);
  const [chartdatas, setChartDatas] = useState<string[]>([]);
  const [focus, setFocus] = useState<boolean>(false);

  useEffect(() => {
    if (props.chartData) {
      const { titles, values } = props.chartData;
      setChartTitle(titles ?? []);
      setChartDatas(values ?? []);
    }
  }, [props.chartData])

  useEffect(() => {
    if (chartTitle) {
      var _chartTitleSimple: any[] = chartTitle.map((item) => {
        let _item = item.split("/")[0];
        _item = (_item.startsWith("0")) ? _item.substring(1) : _item;
        return _item.trimEnd();
      });

      setChartTitleSimple(_chartTitleSimple);
    }
  }, [chartTitle])

  const chartOptions: EChartsOption = {
    legend: {
      show: false,
    },
    title: {
      show: false
    },
    tooltip: {
      show: props.detailed || focus,
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      containLabel: true,
      top: (focus) ? 30 : 15,
      bottom: (focus) ? 55 : 15,
      left: (focus) ? 30 : 15,
      right: (focus) ? 30 : 15,
    },
    xAxis: {
      type: "category",
      data: (props.detailed || focus) ? chartTitle : chartTitleSimple,
      axisLabel: {
        fontWeight: "bold",
      }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        fontWeight: "bold"
      },
    },
    series: [
      {
        data: chartdatas,
        type: "bar",
        itemStyle: {
          color: "#59BAC5"
        },
        label: {
          show: props.detailed || focus,
          position: "top",
          fontWeight: "bold",
        }
      }
    ],
    dataZoom: [
      {
        type: 'slider',
        show: focus,
        start: 0,
        end: 100,
        fillerColor: "#d1e0e0",
        borderColor: "rgb(0,0,0)",
        borderRadius: 8,
        moveHandleSize: 10,
        handleSize: "35px",
        height: "15px",
        moveHandleStyle: {
          color: "#0066ff",
        },
        textStyle: {
          fontWeight: "bold"
        }
      },
      {
        type: 'inside',
        start: 0,
        end: 100,
        disabled: !focus
      },
    ],
  };


  return (
    <>
      {
        !focus &&
        <div
          className={`chartbox ${!props.detailed && "wDash32p"} boxShadowLightBlack`}
          style={{
            height: "100%",
            width: "100%",
            marginRight: "0px"
          }}>
          <div
            className={"row start"}
            style={{
              paddingLeft: "16px",
              paddingTop: "6px",
              color: "#8B90A3",
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between"
            }}>
            {props.title}
            <LcIconLink
              icon={"ppi ppi-expand"}
              tooltip={"Ampliar"}
              onClick={() => setFocus(true)}
            />
          </div>

          <ChartBar
            options={chartOptions}
            onclickBar={(item) => props.onClickBar && props.onClickBar(item)}
          />
        </div>
      }

      <SideModal
        header={props.title + " - Foco"}
        visible={focus}
        onClose={() => setFocus(false)}
        width={(!menu.toggle) ? "calc(100% - 260px)" : "calc(100% - 5rem)"}
      >
        {
          <div className={"row start"} style={{ height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <ChartBar
                options={chartOptions}
                height={"100%"}
                onclickBar={(item) => props.onClickBar && props.onClickBar(item)}
              />
            </div>
          </div>
        }
      </SideModal>
    </>
  );
};

export default BarDetailed;